import TripPriceLoader from '../TripPriceLoader';
import { type PriceObject } from '@search/ItineraryPriceLoader';
import { FlightsApiApiFlightsMinPricesPost } from '@clients/FlightApi';

export default class FlightPriceLoader extends TripPriceLoader {
    override async fetchSinglePrices(
        fromDate: Date,
        toDate: Date,
        origin: string,
        destination: string
    ): Promise<PriceObject[]> {
        const { data } = await FlightsApiApiFlightsMinPricesPost({
            minPriceRequest: {
                AdultCount: this.adultCount,
                ChildCount: this.childCount,
                InfantCount: this.infantCount,
                EndDate: toDate.toISOString(),
                Destination: destination,
                StartDate: fromDate.toISOString(),
                Origin: origin,
            },
        });
        return data
            .filter(d => d.TotalFare)
            .reduce(
                (previousValue, currentValue) => [
                    ...previousValue,
                    {
                        value: currentValue.TotalFare || 0,
                        date: currentValue.Date?.substring(0, 10) || '',
                    },
                ],
                [] as PriceObject[]
            );
    }
}
